/*
sohel  10/06/2022   2701326866  Record Format ->Map Variables ->Search Table Payload Changes, Catagory Lookup and Fixed GAL- 406.
sai krishna  1/3/2023  2701326866 formula rule changed to data calculatio0ns

*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, TextField} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {
  getTableName,
  getTableFieldName,
} from '../../../../../redux/reducers/GlobalField/GlobalField';
import FieldListSearchTable from './FieldListSearchTable';
import {getBaseCategory} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {getLetterConstant} from '../../../../../redux/reducers/LetterMaintainance/LetterSummary';
import RecordFormatFieldSearchTable from './RecordFormatFieldSearchTable';
import {useHistory} from 'react-router';
import * as Yup from 'yup';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
const FieldSearch = ({
  setSearchData,
  searchData,
  setSelectedRows,
  selectedRows,
  fieldListId,
  setFieldListId,
  deletedRules,
  setDeletedRules,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const initialValues = {
    category: '',
    displayName: '',
    globalField: '',
    description: '',
    tableName: '',
    tableField: '',
    fieldType: '',
    code: '',
    tableFieldName: '',
    returnType: '',
    fieldListCode: '',
    fieldListDescription: '',
    baseCategory: '',
  };
  const categoryOptions = [
    {key: 'Core', value: 'Core'},
    {key: 'Payment', value: 'Payment'},
    {key: 'AR', value: 'AR'},
    {key: 'Client', value: 'Client'},
    {key: 'UD', value: 'UD'},
  ];
  const [selectionChange, setSelectionChange] = useState(false);
  const [selectionState, setSelectionState] = useState(true);
  const [fieldListCode1, setFieldListCode] = useState(null);
  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
    // setFieldListId(null);
    setFieldListCode(null);
  };
  const fieldTypeOptions = [
    {key: 'Field List', value: 'Field List'},
    {key: 'BRE Group', value: 'BRE Group'},
    {key: 'Constants', value: 'Constants'},
  ];
  const returnTypes = [
    {key: 'String', value: 'String'},
    {key: 'Number', value: 'Number'},
    {key: 'Boolean', value: 'Boolean'},
    {key: 'Amount', value: 'Amount'},
    {key: 'Date', value: 'Date'},
    {key: 'Phone', value: 'Phone'},
    {key: 'SSN', value: 'SSN'},
    {key: 'Email', value: 'Email'},
  ];

  const [fieldType, setFieldType] = useState('Field List');
  const [globalFieldName, setGlobalFieldName] = useState('');
  const [globalFieldCode, setGlobalFieldCode] = useState('');
  const [submit, setSubmit] = useState(false);
  const [baseCategoryOptions, setBaseCategoryOptions] = useState([]);
  const {tableNameData, tableFieldNameData, isLoading} = useSelector(
    ({globalField}) => globalField,
  );
  const {baseCategoryData} = useSelector(({addFieldList}) => addFieldList);
  const schema = Yup.object().shape({
    fieldListCode: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });
  useEffect(() => {
    dispatch(getBaseCategory());
  }, []);
  useEffect(() => {
    if (fieldType === 'Constants') {
      dispatch(getLetterConstant());
    } else if (fieldType === 'Field List') {
      // dispatch(getBaseCategory());
    }
  }, [fieldType]);
  useEffect(() => {
    setBaseCategoryOptions(baseCategoryData);
  }, [baseCategoryData]);
  const handleReset = (values) => {
    setSearchData(initialValues);
  };

  const onClear = () => {
    const data = {
      category: '',
      displayName: '',
      globalField: '',
      description: '',
      tableName: '',
      tableField: '',
      fieldType: '',
      code: '',
      tableFieldName: '',
      returnType: '',
    };
    setSearchData(data);
  };

  return (
    <div className="col-md-12">
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
          onReset={() => handleReset()}
          validationSchema={schema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
            } = props;

            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div>
                    <ErrorBoundaryForComponents>
                      <div className="form-row">
                        <div className="col-xs-6 col-md-4 form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="fieldType"
                            id="fieldType"
                            size="small"
                            value={fieldType ? fieldType : values.fieldType}
                            options={fieldTypeOptions.map((each) => each.key)}
                            required
                            onChange={(e, value) => {
                              if (value) {
                                setFieldListCode(null);
                                setSelectionChange(false);
                                setFieldType(value);
                                setFieldValue('fieldType', value);
                                setFieldValue('code', '');
                                setFieldValue('displayName', '');
                                setFieldValue('tableField', '');
                                setFieldValue('tableFieldName', '');
                                setFieldValue('tableName', '');
                                setFieldValue('category', '');
                                setFieldValue('fieldListCode', '');
                                setFieldValue('fieldListDescription', '');
                                setFieldValue('baseCategory', '');
                              } else {
                                setFieldValue('fieldType', '');
                              }
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  error={touched.fieldType && errors.fieldType}
                                  variant="outlined"
                                  margin="dense"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Field Type"
                                  placeholder="Select Field Type"
                                  className={` ${classes.labelName} ${classes.selectLabel}`}
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.fieldType && errors.fieldType && errors.fieldType}
                          </FormHelperText>
                        </div>
                        {fieldType === 'Global Field' && (
                          <>
                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="category"
                                id="category"
                                size="small"
                                value={values.category}
                                options={categoryOptions.map((each) => each.key)}
                                required
                                onChange={(e, value) => {
                                  if (value) {
                                    setFieldValue('category', value);
                                    dispatch(getTableName(value));
                                  } else {
                                    setFieldValue('category', '');
                                  }
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      error={touched.category && errors.category}
                                      variant="outlined"
                                      margin="dense"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Category"
                                      placeholder="Select Category"
                                      className={` ${classes.labelName} ${classes.selectLabel}`}
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched.category && errors.category && errors.category}
                              </FormHelperText>
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder="Enter Global Field Name"
                                label="Global Field Name"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="displayName"
                                value={values.displayName}
                                onChange={(e, value) => {
                                  handleChange(e);
                                  setFieldValue('displayName', e.target.value);
                                  setGlobalFieldName(e.target.value);
                                }}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Global Field Code`}
                                label="Global Field Code"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="globalField"
                                value={values.globalField}
                                onChange={(e, value) => {
                                  handleChange(e);
                                  setFieldValue('globalField', e.target.value);
                                  setGlobalFieldCode(e.target.value);
                                }}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="tableName"
                                id="tableName"
                                size="small"
                                value={values.tableName}
                                options={tableNameData}
                                required
                                disabled={values?.category === ''}
                                onChange={(e, value) => {
                                  if (value) {
                                    setFieldValue('tableName', value);
                                    dispatch(getTableFieldName(value));
                                  } else {
                                    setFieldValue('tableName', '');
                                  }
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      error={touched.tableName && errors.tableName}
                                      variant="outlined"
                                      margin="dense"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Table Name"
                                      placeholder="Select Table Name"
                                      className={` ${classes.labelName} ${classes.selectLabel}`}
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched.tableName && errors.tableName && errors.tableName}
                              </FormHelperText>
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="tableFieldName"
                                id="tableFieldName"
                                size="small"
                                value={values.tableFieldName}
                                options={tableFieldNameData}
                                required
                                disabled={!values?.tableName}
                                onChange={(e, value) => {
                                  if (value) {
                                    setFieldValue('tableFieldName', value);
                                  } else {
                                    setFieldValue('tableFieldName', '');
                                  }
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      variant="outlined"
                                      margin="dense"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Table Field Name"
                                      placeholder="Select Table Field Name"
                                      className={` ${classes.labelName} ${classes.selectLabel}`}
                                      error={touched.tableFieldName && errors.tableFieldName}
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched.tableFieldName &&
                                  errors.tableFieldName &&
                                  errors.tableFieldName}
                              </FormHelperText>
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder="Enter Description"
                                label="Description"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <Button
                                variant="contained"
                                type="submit"
                                className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                                disabled
                              >
                                Add New Global Field
                              </Button>
                            </div>
                          </>
                        )}
                        {fieldType === 'BRE Group' && (
                          <>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Formula BRE Group Code`}
                                label="BRE Formula Group Code"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="code"
                                value={values.code}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter BRE Formula Description`}
                                label="BRE Formula Description"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder="Enter Formula Display Name"
                                label="Formula Display Name"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="displayName"
                                value={values.displayName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                id="returnType"
                                options={returnTypes.map((item) => item.value)}
                                size="small"
                                autoHighlight
                                renderInput={(params) => (
                                  <GuiTextField
                                    className={` ${classes.labelName} ${classes.selectLabel}`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    label="Return Type"
                                    name="returnType"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    error={errors.returnType}
                                    placeholder="Select Return Type"
                                  />
                                )}
                                onChange={(e, value) => {
                                  setFieldValue('returnType', value);
                                }}
                              />
                            </div>
                            <div className="col-xs-6 col-md-4 mt-2">
                              <Button
                                variant="contained"
                                type="submit"
                                className={`themeing-buttons  ${classes.buttonRoot}`}
                                onClick={() => history.push('/BRE')}
                              >
                                Add New Data Calculation Group
                              </Button>
                            </div>
                          </>
                        )}
                        {fieldType === 'Field List' && (
                          <>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Field List Code`}
                                label="Field List Code"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="fieldListCode"
                                value={values?.fieldListCode?.toUpperCase()}
                                onChange={handleChange}
                                error={Boolean(touched?.fieldListCode && errors?.fieldListCode)}
                                onBlur={handleBlur}
                                fullWidth
                              />
                              <FormHelperText style={{color: 'red'}}>
                                {touched?.fieldListCode && errors?.fieldListCode ?
                                  errors?.fieldListCode :
                                  ''}
                              </FormHelperText>
                            </div>
                            <div className="col-xs-6 col-md-4 form-group">
                              <TextField
                                margin="dense"
                                variant="outlined"
                                placeholder={`Enter Field List Description`}
                                label="Field List Description"
                                className={` ${classes.labelName} ${classes.inputLabel}`}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                name="fieldListDescription"
                                value={values.fieldListDescription}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                fullWidth
                              />
                            </div>

                            <div className="col-xs-6 col-md-4 form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                id="baseCategory"
                                options={
                                  baseCategoryOptions?.length > 0 ?
                                    baseCategoryOptions :
                                    []
                                }
                                getOptionLabel={(option) => {
                                  return option && option?.categoryName ?
                                    option?.categoryCode === null ?
                                      option?.categoryName :
                                      option?.categoryCode + ' - ' + option?.categoryName :
                                    '';
                                }}
                                value={values?.baseCategory}
                                onChange={(e, value) => {
                                  setFieldValue('baseCategory', value);
                                }}
                                size="small"
                                autoHighlight
                                renderInput={(params) => (
                                  <GuiTextField
                                    className={` ${classes.labelName} ${classes.selectLabel}`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    label="Base Category"
                                    name="baseCategory"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    placeholder="Select Base Category"
                                  />
                                )}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </ErrorBoundaryForComponents>
                  </div>
                  <div className="button-table-spacing-mb">
                    <Button
                      variant="contained"
                      className={`mx-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        handleReset();
                        setFieldType('Field List');
                        setSubmit(true);
                        onClear();
                      }}
                    >
                      Clear
                    </Button>
                    <Button
                      variant="contained"
                      type="submit"
                      className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                    >
                      Search
                    </Button>
                  </div>
                </form>
                {isLoading && <PageLoader />}
              </div>
            );
          }}
        </Formik>
      </div>
      {fieldType === 'Field List' && !fieldListCode1 ? (
        <FieldListSearchTable
          searchData={searchData}
          setFieldListId={setFieldListId}
          setFieldListCode={setFieldListCode}
          fieldListId={fieldListId}
          setSelectionChange={setSelectionChange}
          setSelectionState={setSelectionState}
          submit={submit}
          setSubmit={setSubmit}
        />
      ) : null}
      <RecordFormatFieldSearchTable
        deletedRules={deletedRules}
        setDeletedRules={setDeletedRules}
        searchData={searchData}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        fieldType={fieldType}
        globalFieldCode={globalFieldCode}
        globalFieldName={globalFieldName}
        submit={submit}
        setSubmit={setSubmit}
        fieldListId={fieldListId}
        fieldListCode={fieldListCode1}
        setFieldListId={setFieldListId}
        setFieldListCode={setFieldListCode}
        selectionChange={selectionChange}
        setSelectionChange={setSelectionChange}
        selectionState={selectionState}
        setSelectionState={setSelectionState}
      />
    </div>
  );
};

export default FieldSearch;
